import React, { useEffect } from 'react';
import { useLoaderState } from '../common/state';

export const Loading: React.FC = () => {
    const show = useLoaderState((state) => state.show);
    const hide = useLoaderState((state) => state.hide);

    useEffect(() => {
        show();
        return (): void => hide();
    }, [hide, show]);

    return <></>;
};
